import { useCallback, useEffect, useState } from 'react';
import PlusButton from '../../assets/images/searchBar/plusButton';
import CardBrand from '../../components/cardBrand';
import ChargerModule from '../../components/chargerModule';
import { v4 as uuid } from 'uuid';
import { deleteIdBrand, getBrands, upSert } from '../../services/brands';
import errorMessage from '../../utils/errorMessage';
import alertMessage from '../../utils/alertMessage';

interface IImageDetail {
  url: string;
}
interface IBrands {
  uid?: string;
  id?: string | number;
  name?: string;
  imageId?: number | string;
  image?: IImageDetail;
}

const Brands = () => {
  const headerInfo = { title: 'Marcas', subtitle: '' };
  const infoSideBar = { position: 'brand' };
  const [disabledSaveButton, setDisabledSaveButton] = useState<boolean>(false);
  const [listBrands, setListBrands] = useState<IBrands[]>([]);
  const buttons = [
    {
      title: 'Nuevo',
      color: 'orangeButton',
      action: () => {
        addFormBrand();
      },
      icon: (
        <div className="iconStyle">
          <PlusButton className="iconPositionButton" />
        </div>
      )
    }
  ];

  const addFormBrand = () => {
    const newBrand = { uid: uuid(), id: '', name: '', imgId: '' };
    setListBrands([...listBrands, newBrand]);
  };

  const verifyValidations = (list: IBrands[]) => {
    const disabledButton = list.find(item => !item.name || !item.imageId);
    if (disabledButton) {
      setDisabledSaveButton(true);
    } else {
      setDisabledSaveButton(false);
    }
  };

  const editName = async (dataEdit: IBrands) => {
    try {
      await upSert(dataEdit);
      await consultBrands();
      alertMessage('Los cambios se realizaron correctamente ');
    } catch (error) {
      errorMessage('Ocurrio un error intente mas tarde');
    }
  };

  const debounce = (func: any) => {
    let timer: any;
    return function (...args: any) {
      const context: any = '';
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);
    };
  };

  const handleChange = (value: IBrands, brandId: string | number) => {
    editName(value);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const optimizedFn = useCallback(debounce(handleChange), []);

  const addName = (name?: string, uid?: string, id?: number | string, imageId?: string | number) => {
    const newForms = listBrands.map(item => {
      if (item.uid === uid) {
        return {
          ...item,
          name: name
        };
      }
      return item;
    });
    const dataEdit = {
      name,
      imageId: imageId || 1,
      id
    };
    optimizedFn(dataEdit, id);
    setListBrands([...newForms]);
  };

  const addImgeId = (imageId?: number | string, uid?: string, name?: string, id?: number | string) => {
    const newForms = listBrands.map(item => {
      if (item.uid === uid) {
        return {
          ...item,
          imageId: imageId
        };
      }
      return item;
    });

    const dataEdit = {
      name,
      imageId: imageId || 1,
      id
    };
    editName(dataEdit);
    setListBrands([...newForms]);
  };

  const deleteBrand = (uid: string | number) => {
    const newForms = listBrands.filter(item => item.uid !== uid);
    setListBrands([...newForms]);
    alertMessage('La marca se elimino correctamente');
  };

  const generateCards = () => {
    return listBrands
      .map((item: IBrands, index: number) => {
        return (
          <CardBrand
            addName={(name: string) => {
              addName(name, item?.uid, item?.id, item?.imageId);
            }}
            addImgeId={(imageId: number | string) => {
              addImgeId(imageId, item.uid, item?.name, item?.id);
            }}
            key={index}
            item={item}
            index={index}
            deleteBrand={() => {
              if (item?.uid) {
                optionsDelete(item.uid, item?.id);
              }
            }}
          />
        );
      })
      .reverse();
  };

  const addUidBrands = (listBrands: IBrands[]) => {
    const newList: IBrands[] = [];
    if (listBrands && listBrands.length > 0) {
      for (let brand of listBrands) {
        brand.uid = uuid();
        newList.push(brand);
      }
      return newList;
    }
    return [];
  };

  const consultBrands = async () => {
    const dataBrands = await getBrands();
    const formatData = addUidBrands(dataBrands);
    setListBrands(formatData);
  };

  const optionsDelete = async (uid: string, brandId?: number | string) => {
    if (brandId) {
      try {
        await deleteIdBrand(brandId);
        deleteBrand(uid);
        await consultBrands();
      } catch (error) {
        errorMessage('Ocurrio un error intente mas tarde');
      }
    } else {
      deleteBrand(uid);
    }
  };

  useEffect(() => {
    if (listBrands.length === 0) {
      setDisabledSaveButton(true);
    } else {
      verifyValidations(listBrands);
    }
  }, [listBrands]);

  useEffect(() => {
    consultBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChargerModule
      buttons={buttons}
      headerInfo={headerInfo}
      infoSideBar={infoSideBar}
      //viewSearchBar
      buttonDisabled={disabledSaveButton}
    >
      <div id="brandsModule">
        {false && (
          <button
            onClick={() => {
              upSert({ name: `name-brand-${uuid()}`, imageId: 1 });
            }}
          >
            Create new Brand
          </button>
        )}
        <div className="boxBrandsModule">{generateCards()}</div>
        <div className="h-10" />
      </div>
    </ChargerModule>
  );
};
export default Brands;
